enum TaskPublishChoiceType {
    ACTIVE_TASK = 'ACTIVE_TASK',
    BACKLOG_TASK = 'BACKLOG_TASK',
    PAYMENT = 'PAYMENT',
    CREDIT = 'CREDIT',
    MANUAL = 'MANUAL',
}

export default TaskPublishChoiceType;
